import { Observable, throwError } from 'rxjs';

import { tap, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { IAccessSummary, IResult } from './interfaces';

// import { AuthService } from './auth/auth.service';
// import { AuthConfiguration } from 'angular-auth-oidc-client';
import { environment } from '../../environments/environment';


@Injectable()

export class UserAccessService {

    constructor(private http: HttpClient) {
    }
    
    getAccessSummary(): Observable<IResult<IAccessSummary>> {
        const obs: Observable<IResult<IAccessSummary>> = this.http.get('/api/access/summary')
          .pipe(
            tap((res:IResult<IAccessSummary>) => {
              console.log(  res.data)
              return res.data;
            }),
            catchError(this.handleError)
          );
      
        return obs;
  }
  

  private handleError(error: any) {
    console.log(error);

    // Todo: Hook up to the Flogging infrastructure here

    return throwError(()=>error);
  }
}